import { useAtomValue } from 'jotai';
import Stack from '@mui/material/Stack';
import { useNavbarHeight } from '@/hooks/useNavbarHeight';
import * as state from '@/components/Analysis/state';
import { EquipmentLineBreak, EquipmentsContainer } from '../styles';
import {
  AssembliesFragment,
  ReportInternalType,
} from '@/__generated__/graphql';
import { useEquipmentList, usePointOfInterestDetails } from '../../hooks';
import { ReportSections } from '@/components/Analysis/ReportsRevamped/ReportSections';
import { useBulkAssemblyData } from '../../../ReviewScreen/hooks/useBulkAssemblyData';
import { useGetAssemblyTemplates } from '@/hooks/useGetAssemblyTemplates';

type EquipmentsListProps = {
  reportType: ReportInternalType;
};

export const EquipmentsList = ({ reportType }: EquipmentsListProps) => {
  useGetAssemblyTemplates();
  const selectedReport = useAtomValue(state.selectedReport);
  const equipmentList = useEquipmentList(selectedReport);
  const { groupPoiByEquipmentWithNumbers: groupedPOIs } = usePointOfInterestDetails();
  const navbarHeight = useNavbarHeight();
  const orderOfReport = selectedReport?.reportOrder;

  useBulkAssemblyData({
    assemblyIds:
      selectedReport?.components?.filter(Boolean).map((component) => component?.id) || [],
  });

  return (
    <EquipmentsContainer navbarHeight={navbarHeight}>
      <Stack marginBottom={8}>
        {equipmentList.length === 0 &&
          selectedReport?.components &&
          selectedReport?.components?.at(0) && (
            <ReportSections
              pointsOfInterests={[]}
              reportType={reportType}
              componentId={selectedReport.components?.at(0)?.id ?? undefined}
              equipment={selectedReport.components?.at(0) as AssembliesFragment}
            />
          )}
        {equipmentList.map((equipment, index) => {
          if (!equipment) return null;
          const assemblyId = equipment.id;
          const assemblyName = equipment.tagName;
          const orderedPoiIds = orderOfReport?.poiOrder[assemblyId] || [];
          const orderedPois =
            assemblyId && orderedPoiIds.length > 0
              ? orderedPoiIds.map((id: string) =>
                  groupedPOIs[assemblyName].find((poi) => poi.id === id)
                )
              : groupedPOIs[assemblyName] || [];
          return (
            <>
              <ReportSections
                key={equipment.id}
                equipment={equipment}
                pointsOfInterests={orderedPois}
                reportType={reportType}
              />
              {index !== equipmentList.length - 1 && <EquipmentLineBreak />}
            </>
          );
        })}
      </Stack>
    </EquipmentsContainer>
  );
};
